import React from "react";
import RfiRouter from './Rfi/Router';
export { getFields, getReplyFields } from './Rfi/Router';

export default function RfiPmRouter(props){
    return <RfiRouter {...props} mode='PM' />;
}